import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { Eye, EyeToShootingType } from 'src/models/Eye.model';
import { QualityPrecheckEnum } from 'src/models/Grading.model';

import { useGetCurrentCaptureProcess } from 'src/hooks/camera/useGetCurrentCaptureProcess';
import useUiTranslation from 'src/hooks/useUiTranslation';

interface IImageStatusTextProps {
  imageUrl: string;
  quality?: string;
  hasQualityPrecheck?: boolean;
  isUploading?: boolean;
  isUploadMode?: boolean;
  eyeType?: Eye;
  hasCanceled?: boolean;
}

const ImageStatusText = ({
  imageUrl,
  quality,
  hasQualityPrecheck = true,
  isUploading = false,
  isUploadMode = false,
  eyeType,
  hasCanceled = false,
}: IImageStatusTextProps) => {
  const { tPages } = useUiTranslation();

  const { isCanceling } = useRemoteBoundStore();

  const { currentCaptureProcess } = useGetCurrentCaptureProcess();

  if (isUploading) {
    return (
      <>
        <strong>{tPages('newExam.imageStatus.uploadingImage')}</strong>
        <br />
        {tPages('newExam.imageStatus.uploadingImageDesc')}
      </>
    );
  }

  if (quality === QualityPrecheckEnum.Usable) {
    return (
      <>
        <strong>{tPages('newExam.imageStatus.qualityUsable')}</strong>
        <br />
        {tPages('newExam.imageStatus.qualityUsableDesc')}
      </>
    );
  }

  if (quality === QualityPrecheckEnum.Reject) {
    return (
      <>
        <strong>{tPages('newExam.imageStatus.qualityFailed')}</strong>
        <br />
        {tPages('newExam.imageStatus.qualityFailedDesc')}
      </>
    );
  }

  if (hasQualityPrecheck) {
    return (
      <>
        <strong>{tPages('newExam.imageStatus.qualityAnalysis')}</strong>
        <br />
        {tPages('newExam.imageStatus.qualityAnalysisDesc')}
      </>
    );
  }

  if (
    isCanceling &&
    eyeType &&
    currentCaptureProcess?.take === EyeToShootingType[eyeType]
  ) {
    return (
      <>
        <strong>{tPages('newExam.imageStatus.cancelingImaging')}</strong>
      </>
    );
  }

  if (hasCanceled && !imageUrl) {
    return (
      <>
        <strong>{tPages('newExam.imageStatus.canceled')}</strong>
        <br />
        {tPages('newExam.imageStatus.canceledDesc')}
      </>
    );
  }

  if (!imageUrl) {
    return isUploadMode ? (
      <>
        <strong>{tPages('newExam.imageStatus.noImageUploaded')}</strong>
        <br />
        {tPages('newExam.imageStatus.noImageUploadedDesc')}
      </>
    ) : (
      <>
        <strong>{tPages('newExam.imageStatus.captureInProgress')}</strong>
        <br />
        {tPages('newExam.imageStatus.captureInProgressDesc')}
      </>
    );
  }

  return isUploadMode ? (
    <>
      <strong>{tPages('newExam.imageStatus.uploadedSuccessfully')}</strong>
      <br />
      {tPages('newExam.imageStatus.uploadedSuccessfullyDesc')}
    </>
  ) : (
    <>
      <strong>{tPages('newExam.imageStatus.capturedSuccessfully')}</strong>
      <br />
      {tPages('newExam.imageStatus.capturedSuccessfullyDesc')}
    </>
  );
};

export default ImageStatusText;
